(ns dre.app.api)


(def endpoints
  {:i18n/messages
   {:method :get
    :uri "/messages.edn"
    :static? true}

   :config/config
   {:method :get
    :uri "/config.edn"
    :static? true}

   :config/build-info
   {:method :get
    :uri "/build-info.edn"
    :static? true}

   :stats/who-ictrp
   {:method :get
    :uri "/api/who-ictrp/breakdown-counts"}

   :stats/congresses
   {:method :get
    :uri "/api/doc-congress/breakdown-counts"}

   :stats/feeds
   {:method :get
    :uri "/api/feeds"}

   :auth/check-auth
   {:method :post
    :uri "/api/new-ui/auth/check-auth"}

   :auth/logout
   {:method :post
    :uri "/api/logout"}

   :app/settings
   {:method :get
    :uri "/api/settings"}

   :app/save-settings
   {:method :put
    :uri "/api/settings"}

   :app/notifications
   {:method :get
    :uri "/api/notifications"}

   :app/notifications-mark-read
   {:method :post
    :uri "/api/notifications/mark-read"}

   :widgets/data-sources
   {:method :post
    :uri "/api/articles/term-search-count?category-distribution=true"}

   :widgets/pico-significant-forest
   {:method :post
    :uri "/api/trends/significant-forest"}

   :widgets/top-terms-fast
   {:method :post
    :uri "/api/trends/sense-distribution"}

   :widgets/cooccurrences-matrix-significant-forest
   {:method :post
    :uri "/api/trends/significant-forest"}

   :widgets/cooccurrences-matrix
   {:method :post
    :uri "/api/trends/cooccurrences-matrix"}

   :widgets/top-terms
   {:method :post
    :uri "/api/trends/cooccurrences"}

   :widgets/tag-distribution
   {:method :post
    :uri "/api/trends/tag-distribution"}

   :widgets/study-size
   {:method :post
    :uri "/api/trends/study-size"}

   :widgets/article-categories
   {:method :post
    :uri "/api/trends/article-categories"}

   :widgets/authors
   {:method :post
    :uri "/api/trends/pagerank-authors"}

   :widgets/authors-export
   {:method :post
    :uri "/api/trends/pagerank-authors-export"}

   :widgets/dates-published
   {:method :post
    :uri "/api/trends/distribution"}

   :widgets/dates-changed
   {:method :post
    :uri "/api/trends/distribution"}

   :widgets/burden-of-disease-incidence
   {:method :post
    :uri "/api/trends/ihme"}

   :widgets/burden-of-disease-prevalence
   {:method :post
    :uri "/api/trends/ihme"}

   :widgets/burden-of-disease-deaths
   {:method :post
    :uri "/api/trends/ihme"}

   :widgets/question-answering
   {:method :post
    :uri "/api/recommendations/v2/semantic-search"}

   :widgets/question-answering-single
   {:method :post
    :uri "/api/recommendations/v2/semantic-search"}

   :widgets/question-answering-vote
   {:method :post
    :uri "/api/recommendations/v2/semantic-search-vote"}

   :widgets/question-answering-fetch-vote
   {:method :post
    :uri "/api/recommendations/v2/semantic-search-fetch-vote"}

   :widgets/question-answering-snippets
   {:method :post
    :uri "/api/recommendations/v2/semantic-search-articles-snippets"}

   :dictionary/complete-blueprints
   {:method :post
    :uri "/api/dictionary/complete-blueprints"}

   :dictionary/senses
   {:method :post
    :uri "/api/dictionary/senses"}

   :dictionary/export-labels
   {:method :post
    :uri "/api/dictionary/export-labels"}

   :dictionary/term-similars
   {:method :post
    :uri "/api/dictionary/term-similars"}

   :dictionary/acronyms
   {:method :post
    :uri "/api/lex/infer-acronyms"}

   :dictionary/term-subclass-graph
   {:method :post
    :uri "/api/dictionary/term-subclass-graph"}

   :dictionary/suggestions
   {:method :get
    :uri "/api/dictionary/suggestions"
    :timeout-s 5}

   :dictionary/author-suggestions
   {:method :get
    :uri "api/dictionary/author-suggestions"}

   :search/articles
   {:method :post
    :uri "/api/new-ui/articles"}

   :search/articles-old
   {:method :post
    :uri "/api/articles/term-search"}

   :search/articles-old-count
   {:method :post
    :uri "/api/articles/term-search-count"}

   :search/export
   {:method :post
    :uri "/api/articles/export"}

   :search/export-json
   {:method :post
    :uri "/api/articles/export-json"}

   :search/share-get-entities
   {:method :get
    :uri "/api/sharing/entities"}

   :search/share
   {:method :post
    :uri "/api/sharing/share-query"}

   :admin/feeds
   {:method :get
    :uri "/api/feeds"}

   :admin/feeds.toggle
   {:method :put
    :uri "/api/feeds/:id/toggle"}

   :admin/feeds.update
   {:method :put
    :uri "/api/feeds/:id"}

   :admin/feeds.delete
   {:method :delete
    :uri "/api/feeds/:id"}

   :admin/feeds.add
   {:method :post
    :uri "/api/feeds"}

   :admin/client-download.export-sanofi-csv
   {:method :get
    :uri "/api/articles/export/sanofi/csv"}

   :admin/surveys.export-csv
   {:method :get
    :uri "/api/surveys/results/csv"}

   :admin/help
   {:method :get
    :uri "/api/help/settings"}

   :admin/help.add-topic
   {:method :post
    :uri "/api/help/settings"}

   :admin/help.delete-topic
   {:method :delete
    :uri "/api/help/settings"}

   :admin/help.topic-preview
   {:method :get
    :uri "/api/help/content"}

   :admin/help.confluence-title
   {:method :get
    :uri "/api/help/title"}

   :admin/help.add-article
   {:method :post
    :uri "/api/help/settings"}

   :admin/help.delete-article
   {:method :delete
    :uri "/api/help/settings"}

   :admin/help.change-article-order
   {:method :put
    :uri "/api/help/settings"}

   :admin/usage.events
   {:method :get
    :uri "/api/usage/events"}

   :admin/usage.ai-summary-events
   {:method :get
    :uri "/api/usage/ai-summary-events"}

   :admin/usage.top-clients
   {:method :get
    :uri "/api/usage/top-clients"}

   :admin/usage.top-users
   {:method :get
    :uri "/api/usage/top-users"}

   :saved/signals
   {:method :get
    :uri "/api/signals"}

   :saved/delete-signals
   {:method :delete
    :uri "/api/signals/:id"}

   :saved/update-signal
   {:method :put
    :uri "/api/signals/:id"}

   :saved/add-signal
   {:method :post
    :uri "/api/signals"}

   :saved/tags
   {:method :get
    :uri "/api/tags"}

   :saved/action-tags
   {:method :post
    :uri "/api/tags"}

   :saved/delete-tags
   {:method :delete
    :uri "/api/tags/:id"}

   :saved/edit-tag
   {:method :put
    :uri "/api/tags/:id"}

   :saved/mark-viewed-signal
   {:method :put
    :uri "/api/signals/:id/last-viewed"}

   :saved/mark-visited-signal
   {:method :put
    :uri "/api/signals/:id/last-visited"}

   :saved/search-history
   {:method :get
    :uri "/api/usage/search-history"}

   :sse/polling
   {:method :get
    :uri "/api/fallback"}

   :detail/articles-old-detail
   {:method :get
    :uri "/api/articles/:id"}

   :detail/oa-doi
   {:method :get
    :uri "/api/bibliography/oa"}

   :detail/recommendations
   {:method :get
    :uri "/api/recommendations/v2/:id/:k"}

   :annotator/annotate
   {:method :post
    :uri "api/annotator/annotate"}

   :topic-search/top-terms
   {:method :post
    :uri "/api/trends/cooccurrences"}

   :topic-search/top-terms-fast
   {:method :post
    :uri "/api/trends/sense-distribution"}

   :pubmed-compare/compare
   {:method :post
    :uri "/api/articles/pubmed-compare"}

   :surveys/survey
   {:method :post
    :uri "/api/surveys/:survey-name"}})
